import React from 'react';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import messages from '../../../i18n/en';
import { asyncLanguages } from './async-languages';
const fetchMessagesForLocale = async locale => {
  try {
    var _asyncLanguages$langu, _localeMessages$defau;
    // Fallback to the generic locale if specified one is not found
    const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';

    // Dynamic import of the locale file
    const localeMessages = await ((_asyncLanguages$langu = asyncLanguages[languageLocale]) === null || _asyncLanguages$langu === void 0 ? void 0 : _asyncLanguages$langu.call(asyncLanguages));
    return (_localeMessages$defau = localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.default) !== null && _localeMessages$defau !== void 0 ? _localeMessages$defau : messages;
  } catch (e) {
    // ignore
  }
  return messages;
};
export const AdminhubIntlProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    defaultMessages: messages,
    loaderFn: fetchMessagesForLocale
  }, children);
};